import React, { useState, useEffect, useRef, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import MembersSection from '../components/MembersSection';
import WIA from '../components/WIA';
import EventsSection from '../components/EventsSection';
import ChatSection from '../components/ChatSection';
import PaymentsSection from '../components/PaymentsSection';
import AdminLogin from '../components/AdminLogin';
import Wcash from '../components/Wcash';
import WBusiness from '../components/WBusiness';
import WPartners from '../components/WPartners';
import ContractsManager from '../components/ContractsManager';
import NotificationsPanel from '../components/NotificationsPanel';
import WIALive from '../components/WIALive';
import WIAAdminDashboard from './WIAAdminDashboard';
import BotLinksAdmin from './BotLinksAdmin';
import { getChatMessages, verifyToken, adminLogout, isAdminLoggedIn, getMembers, onCacheUpdate, refreshMembers } from '../services/api';
import { onRealtimeEvent } from '../services/realtime';
import '../styles/wclub-effects.css';

const TAB_MAP = { cards: 'cards', wia: 'wia', events: 'events', chat: 'chat', payments: 'payments', wcash: 'wcash', wbusiness: 'wbusiness', wfriend: 'wbusiness', wpartners: 'wpartners', contracts: 'contracts', 'wia-live': 'wia-live', 'wia-admin': 'wia-admin', 'bot-links': 'bot-links' };

// Menu Items Configuration with SVG Icons
const MENU_ITEMS = [
  { 
    id: 'cards', 
    label: 'Sócios', 
    sublabel: 'Cartões de Membros',
    color: '#d4af37',
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z" />
      </svg>
    )
  },
  { 
    id: 'wia', 
    label: 'W IA', 
    sublabel: 'Assistente Inteligente',
    color: '#8b5cf6',
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
      </svg>
    )
  },
  { 
    id: 'events', 
    label: 'W Event', 
    sublabel: 'Agenda de Eventos',
    color: '#ec4899',
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
      </svg>
    )
  },
  { 
    id: 'chat', 
    label: 'Wchat', 
    sublabel: 'Mensagens Privadas',
    color: '#10b981',
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z" />
      </svg>
    ),
    badge: true
  },
  { 
    id: 'wcash', 
    label: 'Wcash', 
    sublabel: 'Carteira Digital',
    color: '#f59e0b',
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3" />
      </svg>
    )
  },
  { 
    id: 'payments', 
    label: 'W Pay', 
    sublabel: 'Pagamentos',
    color: '#06b6d4',
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
      </svg>
    )
  },
  { 
    id: 'wbusiness', 
    label: 'W Business', 
    sublabel: 'Análises & Métricas',
    color: '#6366f1',
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
      </svg>
    )
  },
  { 
    id: 'wpartners', 
    label: 'W Partners', 
    sublabel: 'Parceiros Globais',
    color: '#14b8a6',
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
      </svg>
    )
  },
  { 
    id: 'contracts', 
    label: 'Contratos', 
    sublabel: 'Gestão de Contratos',
    color: '#ef4444',
    adminOnly: true,
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
      </svg>
    )
  },
  { 
    id: 'wia-live', 
    label: 'W IA Live', 
    sublabel: 'Autenticações em tempo real',
    color: '#22d3ee',
    adminOnly: true,
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 12h.008v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 7.5v4.5l3 1.5" />
      </svg>
    )
  },
  { 
    id: 'wia-admin', 
    label: 'W IA Admin', 
    sublabel: 'Assinaturas · MRR · Renovações',
    color: '#10b981',
    adminOnly: true,
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
      </svg>
    )
  },
  {
    id: 'bot-links',
    label: 'Vínculos Bot',
    sublabel: 'Telegram · WhatsApp · Revogar',
    color: '#22d3ee',
    adminOnly: true,
    icon: (active) => (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke={active ? '#3b82f6' : 'currentColor'} strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
      </svg>
    )
  },
];

const Dashboard = ({ initialTab, initialOpenChat, initialMemberId }) => {
  const [activeTab, setActiveTab] = useState(null); // null = show menu
  const [currentMember, setCurrentMember] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [members, setMembers] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [wbusinessInitialMember, setWbusinessInitialMember] = useState(initialMemberId || null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [cardIndex, setCardIndex] = useState(0);
  const lastReadRef = useRef(Date.now());

  // Load members + auto-poll for external changes (e.g. admin creating from another device)
  useEffect(() => {
    const loadMembers = async () => {
      try {
        const res = await getMembers();
        setMembers(res.data || []);
      } catch (e) {
        console.error('Error loading members:', e);
      }
    };
    
    const initialRefresh = async () => {
      try {
        const res = await refreshMembers();
        setMembers(res.data || []);
      } catch (e) {
        loadMembers();
      }
    };
    initialRefresh();
    
    // Auto-poll members every 20s to detect changes from other devices/sessions
    const pollInterval = setInterval(async () => {
      // Skip polling when tab is hidden to save bandwidth
      if (document.visibilityState !== 'visible') return;
      try {
        const res = await refreshMembers();
        setMembers(res.data || []);
      } catch (e) { /* ignore network errors */ }
    }, 20000);
    
    // Refresh immediately when tab regains focus (e.g. user switches back from another window)
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refreshMembers().then(res => setMembers(res.data || [])).catch(() => {});
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('focus', onVisibilityChange);
    
    // Real-time SSE: instant refresh when any client creates/updates/deletes a member
    const unsubRealtime = onRealtimeEvent((evt) => {
      if (evt?.type && evt.type.startsWith('member.')) {
        refreshMembers().then(res => setMembers(res.data || [])).catch(() => {});
      }
    });
    
    const unsubscribe = onCacheUpdate('members', loadMembers);
    return () => {
      unsubscribe();
      unsubRealtime();
      clearInterval(pollInterval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('focus', onVisibilityChange);
    };
  }, []);

  const handleRefreshMembers = async () => {
    setIsRefreshing(true);
    try {
      const res = await refreshMembers();
      setMembers(res.data || []);
    } catch (e) {
      console.error('Error refreshing members:', e);
    }
    setIsRefreshing(false);
  };

  // Check admin auth
  useEffect(() => {
    const checkAuth = async () => {
      if (isAdminLoggedIn()) {
        const result = await verifyToken();
        setIsAdmin(result.valid && result.is_admin);
      }
      setAuthChecked(true);
    };
    checkAuth();
  }, []);

  // Handle login
  const handleLogin = async (token) => {
    if (token) {
      localStorage.setItem('wclub_admin_token', token);
      const result = await verifyToken();
      setIsAdmin(result.valid && result.is_admin);
    }
    setShowLogin(false);
  };

  // Handle logout
  const handleLogout = () => {
    adminLogout();
    setIsAdmin(false);
    setActiveTab(null);
  };

  // Unread count for chat
  useEffect(() => {
    const checkUnread = async () => {
      if (!currentMember) return;
      try {
        const msgs = await getChatMessages(currentMember.id);
        const unread = msgs.filter(m => 
          m.sender_id !== currentMember.id && 
          new Date(m.created_at).getTime() > lastReadRef.current
        ).length;
        setUnreadCount(unread);
      } catch (e) {}
    };
    if (currentMember) {
      checkUnread();
      const interval = setInterval(checkUnread, 10000);
      return () => clearInterval(interval);
    }
  }, [currentMember]);

  // Handle initial tab from URL
  useEffect(() => {
    if (initialTab && TAB_MAP[initialTab]) {
      setActiveTab(TAB_MAP[initialTab]);
    }
  }, [initialTab]);

  const goHome = () => setActiveTab(null);

  // Filter menu items based on admin status
  const visibleMenuItems = MENU_ITEMS.filter(item => !item.adminOnly || isAdmin);

  return (
    <div className="min-h-screen bg-black">
      <AnimatePresence mode="wait">
        {activeTab === null ? (
          // ===== MAIN MENU SCREEN =====
          <motion.div
            key="menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3 }}
            className="min-h-screen flex flex-col"
            style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
          >
            {/* Header - clean, icons only */}
            <header className="px-6 py-4 flex items-center justify-end">
              <div className="flex items-center gap-3">
                {isAdmin && (
                  <span className="px-3 py-1.5 rounded-full text-[10px] font-['Jost'] uppercase tracking-wider"
                    style={{
                      background: 'linear-gradient(135deg, rgba(59,130,246,0.2) 0%, rgba(59,130,246,0.05) 100%)',
                      border: '1px solid rgba(59,130,246,0.3)',
                      color: '#3b82f6',
                      boxShadow: '0 0 20px rgba(59,130,246,0.2)'
                    }}
                    data-testid="admin-badge"
                  >
                    Admin
                  </span>
                )}
                
                {isAdmin ? (
                  <>
                    <button
                      onClick={() => setShowNotifications(true)}
                      className="p-2.5 transition-all hover:scale-110"
                      data-testid="notifications-btn"
                    >
                      <svg className="w-5 h-5 text-amber-400/80" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                      </svg>
                    </button>
                    <button
                      onClick={handleLogout}
                      className="p-2.5 transition-all hover:scale-110 text-white/60 hover:text-white"
                      data-testid="logout-btn"
                    >
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                    </button>
                  </>
                ) : (
                  <button
                    onClick={() => setShowLogin(true)}
                    className="p-2.5 transition-all hover:scale-110"
                    data-testid="login-btn"
                  >
                    <svg className="w-5 h-5 text-white/70 hover:text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                    </svg>
                  </button>
                )}
              </div>
            </header>

            {/* Menu Grid */}
            <div className="flex-1 px-4 pb-8 overflow-y-auto">
              <div className="max-w-4xl mx-auto">
                {/* Welcome Section */}
                <div className="text-center py-8">
                  <motion.div
                    initial={{ opacity: 0, y: -20, filter: 'blur(10px)' }}
                    animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
                    transition={{ 
                      duration: 0.8, 
                      ease: [0.25, 0.46, 0.45, 0.94]
                    }}
                  >
                    <h2 className="text-3xl font-['Jost'] font-light text-white/90 mb-2">
                      Bem-vindo ao WClub
                    </h2>
                    <p className="text-white/40 text-sm">Selecione uma opção para continuar</p>
                  </motion.div>
                </div>

                {/* Icon Grid - Apple Music Style Staggered Animation */}
                <motion.div 
                  className="grid grid-cols-3 gap-4 md:gap-6"
                  initial="hidden"
                  animate="visible"
                  variants={{
                    hidden: { opacity: 0 },
                    visible: {
                      opacity: 1,
                      transition: {
                        staggerChildren: 0.08,
                        delayChildren: 0.2
                      }
                    }
                  }}
                >
                  {visibleMenuItems.map((item, index) => (
                    <motion.button
                      key={item.id}
                      variants={{
                        hidden: { opacity: 0, y: 60, scale: 0.8, filter: 'blur(10px)' },
                        visible: { 
                          opacity: 1, y: 0, scale: 1, filter: 'blur(0px)',
                          transition: { type: 'spring', stiffness: 100, damping: 12, mass: 0.8 }
                        }
                      }}
                      whileHover={{ scale: 1.05, transition: { type: 'spring', stiffness: 400, damping: 17 } }}
                      whileTap={{ scale: 0.95 }}
                      onMouseEnter={() => setHoveredItem(item.id)}
                      onMouseLeave={() => setHoveredItem(null)}
                      onClick={() => setActiveTab(item.id)}
                      className="relative group aspect-square p-4 flex flex-col items-center justify-center gap-3 touch-manipulation"
                      data-testid={`menu-${item.id}`}
                    >
                      <div className="relative z-10 transition-all duration-300"
                        style={{ color: hoveredItem === item.id ? '#3b82f6' : 'rgba(255,255,255,0.85)', filter: hoveredItem === item.id ? 'drop-shadow(0 0 10px rgba(59,130,246,0.9)) drop-shadow(0 0 20px rgba(59,130,246,0.5))' : 'none' }}>
                        {item.icon(hoveredItem === item.id)}
                      </div>
                      <div className="relative z-10 text-center">
                        <p className="font-['Jost'] font-medium text-sm transition-colors duration-300"
                          style={{ color: hoveredItem === item.id ? '#3b82f6' : 'rgba(255,255,255,0.85)', textShadow: hoveredItem === item.id ? '0 0 10px rgba(59,130,246,0.6)' : 'none' }}>
                          {item.label}
                        </p>
                        <p className="text-[10px] text-white/40 mt-0.5 hidden md:block">{item.sublabel}</p>
                      </div>
                      {item.badge && unreadCount > 0 && (
                        <span className="absolute top-3 right-3 min-w-[20px] h-5 px-1.5 bg-red-500 rounded-full flex items-center justify-center text-[10px] text-white font-bold">
                          {unreadCount > 9 ? '9+' : unreadCount}
                        </span>
                      )}
                      {item.adminOnly && (
                        <span className="absolute top-2 left-2 px-2 py-0.5 bg-blue-500/20 rounded-full text-[8px] text-blue-400 font-medium">ADMIN</span>
                      )}
                    </motion.button>
                  ))}
                </motion.div>
              </div>
            </div>

            {/* Bottom Dock - Quick Access with Staggered Animation */}
            <motion.div
              initial={{ y: 100, opacity: 0, filter: 'blur(10px)' }}
              animate={{ y: 0, opacity: 1, filter: 'blur(0px)' }}
              transition={{ 
                delay: 0.6,
                type: 'spring',
                stiffness: 80,
                damping: 15
              }}
              className="sticky bottom-0 px-4 pb-6"
              style={{ paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 24px)' }}
            >
              <motion.div 
                className="max-w-md mx-auto rounded-2xl p-3 flex items-center justify-around"
                style={{
                  background: 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%)',
                  backdropFilter: 'blur(20px)',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}
                initial="hidden"
                animate="visible"
                variants={{
                  hidden: { opacity: 0 },
                  visible: {
                    opacity: 1,
                    transition: {
                      staggerChildren: 0.1,
                      delayChildren: 0.8
                    }
                  }
                }}
              >
                {['cards', 'chat', 'wia', 'wcash'].map((id, i) => {
                  const item = MENU_ITEMS.find(m => m.id === id);
                  return (
                    <motion.button
                      key={id}
                      variants={{
                        hidden: { opacity: 0, y: 20, scale: 0.5 },
                        visible: { 
                          opacity: 1, 
                          y: 0, 
                          scale: 1,
                          transition: {
                            type: 'spring',
                            stiffness: 200,
                            damping: 15
                          }
                        }
                      }}
                      whileHover={{ scale: 1.2, y: -5 }}
                      whileTap={{ scale: 0.9 }}
                      onClick={() => setActiveTab(id)}
                      className="p-3 rounded-xl"
                      style={{
                        color: 'rgba(255,255,255,0.5)'
                      }}
                    >
                      <div className="w-6 h-6">
                        {item?.icon(false)}
                      </div>
                    </motion.button>
                  );
                })}
              </motion.div>
            </motion.div>
          </motion.div>
        ) : (
          // ===== CONTENT SCREEN =====
          <motion.div
            key={`content-${activeTab}`}
            initial={{ opacity: 0, x: 50, filter: 'blur(8px)' }}
            animate={{ opacity: 1, x: 0, filter: 'blur(0px)' }}
            exit={{ opacity: 0, x: -50, filter: 'blur(8px)' }}
            transition={{ duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="min-h-screen"
          >
            {/* Clean back arrow - top left on all tabs */}

            {/* Content */}
            <div 
              className={`${activeTab === 'wia' || activeTab === 'chat' ? 'h-screen w-screen fixed inset-0' : 'container mx-auto px-3'}`}
              style={{ 
                paddingTop: activeTab === 'wia' || activeTab === 'chat' ? '0' : 'max(calc(env(safe-area-inset-top, 0px) + 44px), 52px)',
                paddingBottom: activeTab === 'wia' || activeTab === 'chat' ? '0' : '100px',
                zIndex: activeTab === 'wia' || activeTab === 'chat' ? 30 : 'auto'
              }}
            >
              {/* Clean back arrow - all inner tabs */}
              <button
                onClick={() => setActiveTab(null)}
                className="fixed z-[60] w-10 h-10 flex items-center justify-center touch-manipulation active:opacity-60 transition-opacity"
                style={{ top: 'max(calc(env(safe-area-inset-top, 0px) + 10px), 14px)', left: '10px' }}
                data-testid="back-btn">
                <svg className="w-5 h-5 text-white/80" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
              </button>
              {activeTab === 'cards' && <MembersSection onSelectMember={setCurrentMember} isAdmin={isAdmin} />}
              {activeTab === 'wia' && <WIA currentMember={currentMember} />}
              {activeTab === 'events' && <EventsSection currentMember={currentMember} isAdmin={isAdmin} />}
              {activeTab === 'chat' && <ChatSection currentMember={currentMember} initialOpenChat={initialOpenChat} />}
              {activeTab === 'wcash' && <Wcash currentMember={currentMember} isAdmin={isAdmin} />}
              {activeTab === 'payments' && <PaymentsSection currentMember={currentMember} />}
              {activeTab === 'wbusiness' && <WBusiness members={members} currentMember={currentMember} initialMemberId={wbusinessInitialMember} onRefresh={handleRefreshMembers} isRefreshing={isRefreshing} />}
              {activeTab === 'wpartners' && <WPartners currentMember={currentMember} isAdmin={isAdmin} />}
              {activeTab === 'contracts' && <ContractsManager isAdmin={isAdmin} />}
              {activeTab === 'wia-live' && isAdmin && <WIALive />}
              {activeTab === 'wia-admin' && isAdmin && <WIAAdminDashboard />}
              {activeTab === 'bot-links' && isAdmin && <BotLinksAdmin />}
            </div>

            {/* Bottom Navigation Dock - Hide on main menu (which IS the navigation), WIA and Chat */}
            {activeTab && activeTab !== 'wia' && activeTab !== 'chat' && (
              <motion.div
                initial={{ y: 100 }}
                animate={{ y: 0 }}
                className="fixed bottom-0 left-0 right-0 px-4 pb-4 z-40"
                style={{ paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 16px)' }}
              >
              <div 
                className="max-w-lg mx-auto rounded-2xl p-2 flex items-center justify-around"
                style={{
                  background: 'linear-gradient(135deg, rgba(10,10,15,0.95) 0%, rgba(15,15,20,0.9) 100%)',
                  backdropFilter: 'blur(20px)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  boxShadow: '0 -4px 30px rgba(0,0,0,0.5)'
                }}
              >
                {['cards', 'chat', 'wia', 'wcash', 'events'].map((id) => {
                  const item = MENU_ITEMS.find(m => m.id === id);
                  const isActive = activeTab === id;
                  return (
                    <button
                      key={id}
                      onClick={() => setActiveTab(id)}
                      className="relative p-3 transition-all"
                      data-testid={`dock-${id}`}
                    >
                      <div 
                        className="w-5 h-5"
                        style={{
                          color: isActive ? '#3b82f6' : 'rgba(255,255,255,0.4)',
                          filter: isActive ? 'drop-shadow(0 0 8px rgba(59,130,246,0.9)) drop-shadow(0 0 16px rgba(59,130,246,0.5))' : 'none'
                        }}
                      >
                        {item?.icon(isActive)}
                      </div>
                      {/* Chat badge */}
                      {id === 'chat' && unreadCount > 0 && (
                        <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 bg-red-500 rounded-full flex items-center justify-center text-[9px] text-white font-bold">
                          {unreadCount > 9 ? '9+' : unreadCount}
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            </motion.div>
            )}
          </motion.div>
        )}
      </AnimatePresence>

      {/* Login Modal */}
      <AnimatePresence>
        {showLogin && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
            onClick={() => setShowLogin(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="w-full max-w-sm"
              onClick={(e) => e.stopPropagation()}
            >
              <div 
                className="rounded-3xl overflow-hidden"
                style={{
                  background: 'linear-gradient(135deg, rgba(15,20,25,0.98) 0%, rgba(10,13,16,0.98) 100%)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  boxShadow: '0 25px 50px rgba(0,0,0,0.5)'
                }}
              >
                <div className="p-6 border-b border-white/[0.06] flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div 
                      className="w-12 h-12 rounded-2xl flex items-center justify-center"
                      style={{
                        background: 'linear-gradient(135deg, rgba(59,130,246,0.2) 0%, rgba(59,130,246,0.05) 100%)',
                        border: '1px solid rgba(59,130,246,0.3)'
                      }}
                    >
                      <svg className="w-6 h-6 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-['Jost'] font-semibold text-white">Admin</h3>
                      <p className="text-xs text-white/40">Acesso restrito</p>
                    </div>
                  </div>
                  <button 
                    onClick={() => setShowLogin(false)} 
                    className="p-2 text-white/40 hover:text-white/70 transition rounded-lg hover:bg-white/[0.05]"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
                <div className="p-6">
                  <AdminLogin onLogin={handleLogin} compact={true} />
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Notifications Panel */}
      <AnimatePresence>
        {showNotifications && (
          <NotificationsPanel 
            isAdmin={isAdmin} 
            onClose={() => setShowNotifications(false)} 
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default Dashboard;
